export const AMOK_HOME_ARTICLE = {
  path: "/blog/how-to-make-fish-amok-at-home",
  title: "How to Make Fish Amok at Home with ANGKOR Amok Curry Paste",
  headline: "How to Make Fish Amok at Home with ANGKOR Amok Curry Paste",
  description:
    "A simple home method for Cambodian Fish Amok using ANGKOR's 280 g Amok Curry Paste ($15, ships Australia-wide), plus tips, swaps and allergen notes.",
  image:
    "/manus-storage/angkor-amok-curry-paste-280g-fish-amok-serving-640_7eb546f2.webp",
  imageAlt: "Fish Amok served with ANGKOR Amok Curry Paste",
  datePublished: "2026-11-04",
  dateLabel: "4 November 2026",
  byline: "By the ANGKOR team",
  excerpt:
    "Make Cambodian Fish Amok at home with ANGKOR’s Amok Curry Paste, with simple steps, swaps and allergen notes.",
  secondImage:
    "/manus-storage/angkor-amok-curry-paste-280g-single-jar-640_1aa17c61.webp",
  secondImageAlt: "ANGKOR Amok Curry Paste 280 g jar",
} as const;
